import React from 'react'
import { Typography, Stack, Button, Card, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { AppHeader } from 'components/app'
import SendIcon from '@mui/icons-material/Send'
import './Score.scss'
import { useGlobalState } from 'state'
import * as api from 'common/api'
import { blue, grey } from '@mui/material/colors'


export const Score = () => {
  const state = useGlobalState()
  const location = useLocation()
  const navigate = useNavigate()
  const scorepoint = location.state.scorepoint || {}
  const targetUrl = scorepoint['s3_key'] === undefined ? '' : 'https://dznfxuvgky742.cloudfront.net/' + scorepoint['s3_key']

  const [privacyDialog, setPrivacyDialog] = React.useState(false)
  const [sendDialog, setSendDialog] = React.useState(false)

  const getValue = (key: string, digits?: number): string => {
    if (scorepoint[key] === undefined) {
      return ''
    } else {
      return parseFloat(scorepoint[key]).toFixed(digits === undefined ? 1 : digits)
    }
  }

  const rank = React.useMemo((): number => {
    const score = Number(getValue('J4', 0))
    if (score >= 90) {
      return 5
    } else if (score >= 80) {
      return 4
    } else if (score >= 65) {
      return 3
    } else if (score >= 45) {
      return 2
    } else if (score >= 15) {
      return 1
    } else {
      return 0
    }
  }, [scorepoint])

  const getSinsuiValue = (key: string): string => {
    if (scorepoint[key] === undefined) {
      return ''
    } else {
      const num = parseFloat(scorepoint[key])
      if (isFinite(num)) {
        return num.toFixed(2) + ' m'
      } else {
        return scorepoint[key]
      }
    }
  }

  const send = async () => {
    let sended = false
    state.app.setLoading(true)
    try {
      const res = await api.post('/email', {
        emailAddress: state.app.getAnswer(-1, 3)?.value,
        companyName: state.app.getAnswer(-1, 1)?.value,
        staffName: state.app.getAnswer(-1, 2)?.value,
        propertyName: state.app.getAnswer(-1, 5)?.value,
        rank: rank,
        url: targetUrl,
      })
      if (res !== null && res.result === 'success') {
        sended = true
      }
    } catch (e) {
      console.log(e)
    } finally {
      state.app.setLoading(false)
      if (sended) {
        alert('メールを送信しました。')
        setSendDialog(false)
      } else {
        alert('メール送信に失敗しました。')
      }
    }
  }

  return (
    <Stack className='score-page' direction={'column'} alignItems="center" sx={{backgroundColor: 'white'}} minHeight={'100dvh'}>
      <AppHeader/>

      <Stack
        component={Card}
        elevation={2}
        width={'80%'}
        minWidth={400}
        maxWidth={700}
        px={5}
        py={5}
        my={4}
        sx={{
          backgroundColor: grey[50],
          position: 'relative',
        }}
        direction={'column'}
        alignItems={'center'}
      >
        <Typography variant='h4' mb={1}>{'自己査定結果'}</Typography>
        <Typography variant='body1' mb={4}>{'この結果はあくまで自己査定結果です。本評価とは結果が異なる可能性がありますのでご注意ください。なお、この結果を第三者に開示したり、各種掲載物に掲載することはできません。'}</Typography>
        <Button startIcon={<SendIcon />} variant='contained' color='info' onClick={() => setSendDialog(true)}>自己査定結果をメールで受け取る</Button>
        <Typography variant='body2' my={1} color={'GrayText'}>※ 回答内容はメールに添付されます</Typography>
      </Stack>

      <Button variant='contained' onClick={() => navigate('/qlist', {replace: false})}>設問一覧に戻る</Button>

      <Dialog
        open={sendDialog}
        onClose={() =>setSendDialog(false)}
      >
        <DialogTitle align='center'>
          { '自己査定結果をメールで受け取る' }
        </DialogTitle>
        <DialogContent sx={{maxWidth: 460}}>
          <Stack spacing={3}>
            <Typography>本画面にて（一財）日本不動産研究所に提供された情報は
              <u style={{color: blue[700], cursor: 'pointer'}}><a onClick={() => setPrivacyDialog(true)}>プライバシーポリシー</a></u>
              に則り、取り扱いに十分配慮するものとします。
            </Typography>
            <TextField label="メールアドレス" variant="standard" value={state.app.getAnswer(-1, 3)?.value} InputProps={{readOnly: true}} />
            <TextField label="会社名" variant="standard" value={state.app.getAnswer(-1, 1)?.value} InputProps={{readOnly: true}} />
            <TextField label="物件名" variant="standard" value={state.app.getAnswer(-1, 5)?.value} InputProps={{readOnly: true}} />

            <Typography>
              上記内容に間違いがある場合は、キャンセルを押して設問一覧より基本情報の入力を修正してください
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSendDialog(false)} autoFocus>
            キャンセル
          </Button>
          <Button variant='contained' onClick={send}>
            送信
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={privacyDialog}
        onClose={() =>setPrivacyDialog(false)}
      >
        <DialogTitle align='center'>
          { 'プライバシーポリシー' }
        </DialogTitle>
        <DialogContent>
          <Stack>
            <Typography>（個人情報の利用目的等に関する表示）</Typography>
            <Typography>認証機関である一般財団法人日本不動産研究所が当該自己査定システムのご利用によって取得する個人情報の利用目的は以下のとおりです。</Typography>
            <ul>
              <li>不動産レジリエンス認証に関する各種情報の提供・連絡</li>
              <li style={{marginTop: 10}}>
                当該自己査定システムの利用状況のモニタリング
              </li>
              <li style={{marginTop: 10}}>
                当該自己査定システムにて入力して頂いた情報は、不動産レジリエンス認証の運営に関連した上記の目的に限り利用させていただきます。
                これ以外の場合においてご本人の許可なく第三者へ情報公開することはありません。
                なお、個人情報保護法第24条第1項に定める事項については、<a href='https://www.reinet.or.jp/' target='_blank' rel="noreferrer">一般財団法人日本不動産研究所</a>をご覧ください。
              </li>
            </ul>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPrivacyDialog(false)} autoFocus>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}
